const {
  enumerateWildcardPath,
  mutateContentValue
} = require('@truqc/content-path');

/**
  * @function evalute - evaluate formCollectionBehavior
  */

const evaluate = async (source, contentIn, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  const formTypeIdentifier = await sourceEvaluator(source.formTypeIdentifier);
  if (formTypeIdentifier === undefined) {
    return undefined;
  }
  const excluding = await sourceEvaluator(source.excluding);
  const jobFormID = await sourceEvaluator(source.jobFormID);
  const keep = (await sourceEvaluator(source.keep)) || [];
  if (!keep.includes('title')) {
    keep.push('title');
  }
  const querySource = {
    type: 'queryEntityBehavior',
    entityName: 'Form',
    properties: ['content'],
    equals: {
      'formType/identifier': formTypeIdentifier
    }
  };
  if (excluding !== undefined) {
    querySource.equalsNoneOf = {
      id: excluding
    };
  }
  const retrievedForms = await sourceEvaluator(querySource);
  if (retrievedForms === undefined) {
    return undefined;
  }
  const collection = {};
  retrievedForms.forEach((form, index) => {
    const {
      id,
      content: contentString
    } = form;
    const content = JSON.parse(contentString);
    const {
      job = {}
    } = content;
    if (jobFormID !== undefined && Object.keys(job)[0] === jobFormID) {
      const item = {
        _created: index
      };
      keep.forEach(wildcardPath => {
        enumerateWildcardPath(content, wildcardPath, (path, value) => {
          mutateContentValue(path, item, value);
        });
      });
      collection[id] = item;
    }
  });
  return collection;
};
module.exports = {
  evaluate
};